const FilterSkeleton = () =>{
  return(
    <div>
      <h1 className="font-bold pb-4">Quick Filter</h1>
      <div className="flex flex-row justify-between items-center">
          <span className="font-bold text-gray-500 w-1/6">Filter by:</span>
          <span className="bg-gray-200 rounded-lg p-4 mx-2 animate-pulse w-1/6 h-10"></span>
          <span className="bg-gray-200 rounded-lg p-4 mx-2 animate-pulse w-1/6 h-10"></span>
          <span className="bg-gray-200 rounded-lg p-4 mx-2 animate-pulse w-1/6 h-10"></span>
          <span className="bg-gray-200 rounded-lg p-4 mx-2 animate-pulse w-1/6 h-10"></span>
          <span className="bg-gray-200 rounded-lg p-4 mx-2 animate-pulse w-1/6 h-10"></span>
      </div>
    </div>
  )
}

const AccountStatusSkeleton = () =>{
    return(
      <div className="bg-white flex flex-col item-start shadow-lg rounded-lg p-4 mb-4 w-full h-fit">
            <h1 className="bg-gray-200 rounded animate-pulse"></h1>
            <div className="flex flex-row justify-between">
                <div className=" bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse"></div>
                <div className=" bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse"></div>
                <div className=" bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse"></div>
                <div className=" bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse"></div>
                <div className=" bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse"></div>
                <div className=" bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse"></div>
            </div>
        </div>
    )
}

const YoursTableSkeleton = () => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
        <thead>
          <tr className="text-gray-400 border-t">
            <th className="py-2 px-4 border-b text-left w-1/12">ID</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Product</th>
            <th className="py-2 px-4 border-b text-left w-3/12">Name</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Churn Likelihood</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Profile Name</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Last Transacted</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Last Interacted</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Action</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountInventoryPaginationSkeleton = () => {
  return (
      <div className="flex justify-between items-center border-t border-gray-200 p-4">
          <div className="flex flex-row gap-2">
              <div className="h-5 w-48 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-5 w-40 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div className="flex gap-1">
              <div className="h-8 w-32 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-20 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-24 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
          </div>
      </div>
  );
};

const AllTableSkeleton = () => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
        <thead>
          <tr className="text-gray-400 border-t">
            <th className="py-2 px-4 border-b text-left w-1/12">ID</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Product</th>
            <th className="py-2 px-4 border-b text-left w-3/12">Name</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Churn Likelihood</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Profile Name</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Last Transacted</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Last Interacted</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Owner</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Action</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountTableSearchbarSkeleton = () => {
  return (
    <div className="relative w-[400px]">
      <div className="absolute inset-y-0 left-3 flex items-center">
        <div className="w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
      </div>
      <div className="w-full h-[42px] pl-10 pr-4 rounded-full border border-gray-300 bg-gray-100 animate-pulse"></div>
    </div>
  );
};

export {FilterSkeleton, AccountStatusSkeleton, YoursTableSkeleton, AccountInventoryPaginationSkeleton, AllTableSkeleton, AccountTableSearchbarSkeleton};